import { Component } from '@angular/core';

// Styles from legacy dashboard that still need including
import 'dashboard/css/style.less';
import 'go-styles/src/goreact-style.less';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
